import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <React.Fragment>
      <footer className="nh_footer-area h2_nh_footer-area">
        <div className="nh_footer-main pt-80 pb-20">
          <div className="container">
            <div className="row justify-content-between">
              <div className="col-lg-4 col-sm-6">
                <div className="nh_footer-widget mb-40 mr-70">
                  <div className="nh_footer-widget-logo">
                    <a href="index.html">
                      <img src="/images/logo.png" alt="logo" width={170} />
                    </a>
                  </div>
                  <p className="nh_footer-widget-text">
                    Mitra Recharge, powered by PANMITRA ONLINE SERVICE PVT.
                    LTD., offers fast and secure Mobile, DTH, and Google Play
                    recharge services. We provide a seamless experience with
                    instant transactions, attractive commissions, and 24/7
                    support.
                  </p>
                  <div className="nh_footer-widget-social">
                    <a href="#">
                      <i className="fa-brands fa-facebook-f" />
                    </a>
                    <a href="#">
                      <i className="fa-brands fa-twitter" />
                    </a>
                    <a href="#">
                      <i className="fa-brands fa-linkedin-in" />
                    </a>
                    <a href="#">
                      <i className="fa-brands fa-youtube" />
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-lg-2 col-sm-4">
                <div className="nh_footer-widget mb-35">
                  <h4 className="nh_footer-widget-title">Quick Links</h4>
                  <ul>
                    <li>
                      <a href="/">
                        <i className="fa-regular fa-angle-right" /> Home
                      </a>
                    </li>
                    <li>
                      <a href="/about_us">
                        <i className="fa-regular fa-angle-right" /> About Us
                      </a>
                    </li>
                    <li>
                      <a href="/our_services">
                        <i className="fa-regular fa-angle-right" /> Our Services
                      </a>
                    </li>
                    <li>
                      <a href="/terms_and_conditions">
                        <i className="fa-regular fa-angle-right" /> Terms &
                        Conditions
                      </a>
                    </li>
                    <li>
                      <a href="/privacy_policy">
                        <i className="fa-regular fa-angle-right" /> Privacy
                        Policy
                      </a>
                    </li>
                    <li>
                      <a href="/refund_policy">
                        <i className="fa-regular fa-angle-right" /> Refund
                        Policy
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-2 col-sm-4 d-flex justify-content-lg-center order-sm-3 order-lg-2">
                <div className="nh_footer-widget mb-35">
                  <h4 className="nh_footer-widget-title">Our Services</h4>
                  <ul>
                    <li>
                      <a href="/our_services">
                        <i className="fa-regular fa-angle-right" /> Mobile
                        Recharge
                      </a>
                    </li>
                    <li>
                      <a href="/our_services">
                        <i className="fa-regular fa-angle-right" /> DTH Recharge
                      </a>
                    </li>
                    <li>
                      <a href="/our_services">
                        <i className="fa-regular fa-angle-right" /> Google Play
                        Recharge
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-4 col-sm-6 order-sm-2 order-lg-3">
                <div className="nh_footer-widget mb-40 ml-50">
                  <h4 className="nh_footer-widget-title pb-06">
                    Subscribe To Our Newsletter
                  </h4>
                  <form
                    action="/"
                    method="GET"
                    className="nh_footer-widget-form"
                  >
                    <input type="email" placeholder="Email Address" />
                    <button type="button">Subscribe Now</button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="nh_footer-contact pb-30 d-none d-lg-block">
          <div className="container">
            <div className="nh_footer-contact-wrap">
              <div className="nh_footer-contact-item">
                <div className="nh_footer-contact-item-icon">
                  <i className="fa-light fa-location-dot" />
                </div>
                <div className="nh_footer-contact-item-content">
                  <span>Location</span>
                  <h4>
                    Belgaum, Karnataka, <br />
                    India - 590009
                  </h4>
                </div>
              </div>
              <div className="nh_footer-contact-item">
                <div className="nh_footer-contact-item-icon">
                  <i className="fa-light fa-envelope" />
                </div>
                <div className="nh_footer-contact-item-content">
                  <span>Email</span>
                  <h4>
                    <a href="mailto:mitrarechargeapp@gmail.com">
                      mitrarechargeapp@gmail.com
                    </a>
                  </h4>
                </div>
              </div>
              <div className="nh_footer-contact-item">
                <div className="nh_footer-contact-item-icon">
                  <i className="fa-solid fa-phone-volume" />
                </div>
                <div className="nh_footer-contact-item-content">
                  <span>Call Now</span>
                  <h4>
                    <a href="tel:919632456111">+91 9632456111</a>
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="nh_footer-bottom pt-20 pb-20">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <div className="nh_footer-copyright mb-10 mb-md-0 text-center text-md-start">
                  <p>
                    All Rights Reserved © 2024{" "}
                    <a href="/">PANMITRA ONLINE SERVICE PVT. LTD.</a>
                  </p>
                </div>
              </div>
              <div className="col-md-6">
                <div className="nh_footer-menu">
                  <ul className="justify-content-center justify-content-md-end">
                    <li>
                      <a href="/terms_and_conditions">Terms &amp; Conditions</a>
                    </li>
                    <li>
                      <a href="/privacy_policy">Privacy Policy</a>
                    </li>
                    <li>
                      <a href="/refund_policy">Refund Policy</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </React.Fragment>
  );
};

export default Footer;
